<template>
  <v-col v-if="value" class="d-none d-xl-flex flex-grow-0" align="center">
    <div
      class="text-caption text-uppercase"
      style="writing-mode: vertical-rl"
      :style="{ opacity, transform: `rotate(${flip ? 0 : -180}deg)` }"
    >
      {{ value }}
    </div>
  </v-col>
</template>

<script setup>
defineProps({
  flip: {
    default: false,
    type: Boolean
  },
  opacity: {
    default: 1,
    type: Number
  },
  value: {
    default: undefined,
    type: String
  }
})
</script>
